const consentSwitchReducer = (defaultValue = false, action) => {
    switch(action.type) {
        case 'SETALL_CONSENTSWITCH':
            return action.payload;
        default:
            return defaultValue;
    }
};

export default consentSwitchReducer;